import { Card, CardBody } from "@chakra-ui/react";
import AppPage from "layouts/AppPage";
import { useParams } from "react-router";
import QueryError from "components/Error/QueryError";
import CaminoBreadcrumbs from "components/Breadcrumbs";
import { SHARED_ROUTES } from "definitions/constants/routeConstants";
import { MeetingEventDetails, useMeetingEventDetailQuery } from "features/MeetingEvents";

export default function MeetingEventPage() {
  const { id } = useParams<{ id: string; }>();
  const { data, isLoading, error: queryError, isError } = useMeetingEventDetailQuery(id);

  if (!id) {
    return <AppPage>Meeting not found</AppPage>;
  }

  if (isLoading) {
    return <AppPage>Loading...</AppPage>;
  }

  if (!data && isError) {
    return (<QueryError queryError={queryError} resourceName="Meeting" id={id} />);
  }

  return (
    <AppPage>
      <CaminoBreadcrumbs
        breadcrumbInfos={[
          { name: "Meetings", toUrl: SHARED_ROUTES.meetingEvents.index },
          { name: `${data?.title || "Meeting"}` },
        ]}
      />
      {data && (
        <Card>
          <CardBody>
            <MeetingEventDetails meetingEvent={data} />
          </CardBody>
        </Card>
      )}
    </AppPage>
  );
}
